import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import * as styles from './CommentTimestamp.module.scss';
import Button from '../../components/Button';
import Timestamp from '../../components/Timestamp';
import type { Scalars } from '../../graphql/generated/graphql';

interface CommentTimestampProps {
  insertedAt: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
  onClick?: () => void;
}

const FORMAT = 'h:mma, MMM D, YYYY';

const CommentTimestamp = ({
  insertedAt,
  updatedAt,
  onClick,
}: CommentTimestampProps) => {
  const isEdited = updatedAt && insertedAt !== updatedAt;

  const tooltip = isEdited
    ? `Edited ${moment(updatedAt).format(FORMAT)}`
    : moment(insertedAt).format(FORMAT);

  const timestamp = (
    <span className={styles.timestamp} title={tooltip}>
      <Timestamp date={insertedAt} format="short" />
      {!!isEdited && ' (edited)'}
    </span>
  );

  return onClick ? (
    <Button
      onClick={onClick}
      className={classNames(styles.timestamp, styles.timestampButton)}
    >
      {timestamp}
    </Button>
  ) : (
    timestamp
  );
};

export default CommentTimestamp;
